import { render, staticRenderFns } from "./EditGroupsView.vue?vue&type=template&id=dd516650&scoped=true&"
import script from "./EditGroupsView.vue?vue&type=script&lang=ts&"
export * from "./EditGroupsView.vue?vue&type=script&lang=ts&"
import style0 from "./EditGroupsView.vue?vue&type=style&index=0&id=dd516650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd516650",
  null
  
)

export default component.exports